import styled from "styled-components"

const ListContainer = styled.div`
  background-color: white;
`

const StyledAdresseItem = styled.li`
  background-color: ${(props) =>
    props.active === true && props.clickable === true
      ? props.theme.a_color_gradients.a_dark
      : props.clickable === true
      ? "white"
      : props.theme.a_color_gradients.a_light};
  color: black;
  & a {
    color: black;
  }
`

export { ListContainer, StyledAdresseItem }
